import React, { useEffect, useState } from "react";
import "./statistics_header.css";
import LoadingScreenDenda from "../Unique/Animation/loading_screen";
import { get } from "../../lib/api";

const PageStatisticsHeader = ({ game_id }) => {
  const [gameplays, setGameplays] = useState([0, 0, 0, 0]);
  const [ads, setAds] = useState([0, 0, 0, 0]);
  // const [, setPeriods] = useState(["Today", "Yesterday", "Current Month", "Last Month"]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    function ensureNumber(value) {
      return isNaN(value) || value == null ? 0 : value;
    }

    const fetchData = async () => {
      if (game_id === null) return;
      setLoading(true);
      const data = await get(`/statistics?method=getHeaderStatisticsNew&gameid=${game_id}`);

      // console.log('THE TYPE OF ADS TODAY:');
      // console.log(typeof data['Ads Today']);
      // let ads_this_month_calc = parseInt(data['Ads Current Month'])+parseInt(data['Ads Today']);
      // let gp_this_month_calc = parseInt(data['Gameplays Current Month'])+parseInt(data['Gameplays Today']);
      let ads_this_month = (ensureNumber(parseInt(data["Ads Current Month"])) + ensureNumber(parseInt(data["Ads Today"]))).toString(); //
      let gp_this_month = (ensureNumber(parseInt(data["Gameplays Current Month"])) + ensureNumber(parseInt(data["Gameplays Today"]))).toString(); //
      setGameplays([data["Gameplays Today"], data["Gameplays Yesterday"], gp_this_month, data["Gameplays Last Month"]] || []);
      setAds([data["Ads Today"], data["Ads Yesterday"], ads_this_month, data["Ads Last Month"]] || []);
      // setPeriods(data['period']);
      setLoading(false);
    };

    fetchData();
  }, [game_id]); // Dependency on game_id

  if (loading) {
    return <LoadingScreenDenda text={"Loading"} />; // Render a loading component or null
  }

  return (
    <>
      <div className={`dashboard `}>
        <div className="metrics">
          {/* Using optional chaining (?.) to access elements and providing a fallback value */}
          <div className="metric">
            <h2>Gameplay Today</h2>
            <p>{gameplays?.[0] ? Intl.NumberFormat("de-DE").format(gameplays[0]) : "..."}</p>
          </div>
          <div className="metric">
            <h2>Gameplay Yesterday</h2>
            <p>{gameplays?.[1] ? Intl.NumberFormat("de-DE").format(gameplays[1]) : "..."}</p>
          </div>
          <div className="metric">
            <h2>Gameplay This Month</h2>
            <p>{gameplays?.[2] ? Intl.NumberFormat("de-DE").format(gameplays[2]) : "..."}</p>
          </div>
          <div className="metric">
            <h2>Gameplay Previous Month</h2>
            <p>{gameplays?.[3] ? Intl.NumberFormat("de-DE").format(gameplays[3]) : "..."}</p>
          </div>
          <div className="metric">
            <h2>Ads Today</h2>
            <p>{ads?.[0] ? Intl.NumberFormat("de-DE").format(ads[0]) : "..."}</p>
          </div>
          <div className="metric">
            <h2>Ads Yesterday</h2>
            <p>{ads?.[1] ? Intl.NumberFormat("de-DE").format(ads[1]) : "..."}</p>
          </div>
          <div className="metric">
            <h2>Ads This Month</h2>
            <p>{ads?.[2] ? Intl.NumberFormat("de-DE").format(ads[2]) : "..."}</p>
          </div>
          <div className="metric">
            <h2>Ads Previous Month</h2>
            <p>{ads?.[3] ? Intl.NumberFormat("de-DE").format(ads[3]) : "..."}</p>
          </div>
        </div>
      </div>
      <hr />
    </>
  );
};

export default PageStatisticsHeader;
